import * as React from 'react';

import {
    Box,
    Typography, 
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocationImpactDetail from './LocationImpactDetail';
import AddImpact from "./AddImpact";
import { LOCAL_CONSTANT } from "../../Const";
import { setPermissionFunc } from "../../components/PermissionFunc";
import { useAppSelector } from "../../../app/hooks";
import { useUserContext } from "../../../user-provider";

export interface LocationImpactProps {
    props: {
        plan_area_id: string;
        indexKey: number;
        locationImpact: any;
        impact: any;
        latlng: any;
        handleSetReadApi: any;
    }
}

const LocationImpact: React.FC<LocationImpactProps> = ({ props }) => {
    const user = useUserContext();
    const [expanded, setExpanded] = React.useState(false);
    const [open, setOpen] = React.useState<boolean>(false);
    const [targetImpact, setTargetImpact] = React.useState<any>();
    const [userType, setUserType] = React.useState("");
    const objLocationBase = useAppSelector(
        (state) => state.longPage.locationBase
    );

    const handleChangeExpanded = (event: any, newValue: any) => {
        setExpanded(newValue);
    };

    //ユーザー取得タイミングによる画面制御
    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    // ルート変更
    const onClickHandle = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        e.stopPropagation();
        setTargetImpact(props.impact);
        setOpen(true);
    };

    return (
        <>
            {
                <Accordion key={props.indexKey} expanded={expanded} onChange={handleChangeExpanded}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="StoreOpeningConditions-content"
                        id="StoreOpeningConditions-header"
                        sx={{
                            '& .MuiAccordionSummary-expandIconWrapper': {
                                position: 'absolute',
                                left: '10px',
                            }
                        }}
                    >
                        <Typography sx={{ paddingLeft: '30px', width: '50%' }}>
                            {props.impact.tenpo_name}店（{props.impact.store_code}）
                        </Typography>
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={(e) => onClickHandle(e)}
                            disabled={setPermissionFunc(
                                userType,
                                objLocationBase.task_id,
                                LOCAL_CONSTANT.NAVI.IMPACT,
                                "change_route"
                            )}
                        >
                            ルート変更
                        </Button>
                    </AccordionSummary>
                    <AccordionDetails>
                        <LocationImpactDetail props={{
                            plan_area_id: props.plan_area_id,
                            locationImpact: props.locationImpact,
                            impactData: props.impact,
                            handleSetReadApi: props.handleSetReadApi,
                            expanded: expanded,
                            latlng: props.latlng,
                        }} />
                    </AccordionDetails>
                </Accordion>
            }
            <Box sx={{ margin: "10px" }}>
                <AddImpact
                    props={{
                        open: open,
                        handleModal: setOpen,
                        mode: "edit",
                        latlng: props.latlng,
                        locationImpactList: props.locationImpact,
                        targetImpact: targetImpact,
                        handleSetReadApi: props.handleSetReadApi,
                    }}
                />
            </Box>
        </>
    )
}

export default LocationImpact;
